// AdminProductApplications.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Slidar } from "../AdminDashbord/Slidar"; 
import '../../../src/Components/StudentApplicationForm/StudentApplicationForm.css';// ✅ Import CSS like StudentApplicationForm.css

const BASE_URL = "/api/sells-applications";

const AdminProductApplications = () => {
  const [applications, setApplications] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    productTitle: "",
    name: "",
    email: "",
    phone: "",
    companyName: "",
    companyLocation: "",
    description: "",
  });

  // Fetch applications
  const fetchApplications = async () => {
    try {
      const res = await axios.get(BASE_URL);
      setApplications(res.data);
    } catch (err) {
      console.error("Error fetching applications:", err);
      alert("Failed to fetch applications.");
    }
  };

  useEffect(() => {
    fetchApplications();
  }, []);

  // Handle form input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Edit mode
  const handleEdit = (app) => {
    setEditingId(app._id);
    setFormData({
      productTitle: app.productTitle,
      name: app.name,
      email: app.email,
      phone: app.phone,
      companyName: app.companyName,
      companyLocation: app.companyLocation,
      description: app.description,
    });
  };

  const handleCancel = () => {
    setEditingId(null);
    setFormData({
      productTitle: "",
      name: "",
      email: "",
      phone: "",
      companyName: "",
      companyLocation: "",
      description: "",
    });
  };

  const handleUpdate = async (id) => {
    try {
      await axios.put(`${BASE_URL}/${id}`, formData);
      alert("Application updated successfully!");
      fetchApplications();
      handleCancel();
    } catch (err) {
      console.error("Error updating application:", err);
      alert("Failed to update application. Try again.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this application?")) {
      try {
        await axios.delete(`${BASE_URL}/${id}`);
        alert("Application deleted successfully!");
        fetchApplications();
      } catch (err) {
        console.error("Error deleting application:", err);
        alert("Failed to delete application. Try again.");
      }
    }
  };

  return (
    <div className="admin-layout"> {/* ✅ same wrapper class */}
      <Slidar />
      <div className="student-main-content"> {/* ✅ same content container */}
        <h2>Supply To Us</h2>

        <div className="table-wrapper"> {/* ✅ same wrapper class for scroll */}
          <table className="student-table"> {/* ✅ same table class */}
            <thead>
              <tr>
                <th>Product Title</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Company Name</th>
                <th>Company Location</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {applications.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No applications found.
                  </td>
                </tr>
              ) : (
                applications.map((app) => (
                  <tr key={app._id}>
                    <td>
                      {editingId === app._id ? (
                        <input
                          name="productTitle"
                          value={formData.productTitle}
                          onChange={handleChange}
                          disabled
                        />
                      ) : (
                        app.productTitle
                      )}
                    </td>
                    <td>
                      {editingId === app._id ? (
                        <input
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      ) : (
                        app.name
                      )}
                    </td>
                    <td>
                      {editingId === app._id ? (
                        <input
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          disabled
                        />
                      ) : (
                        app.email
                      )}
                    </td>
                    <td>
                      {editingId === app._id ? (
                        <input
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      ) : (
                        app.phone
                      )}
                    </td>
                    <td>
                      {editingId === app._id ? (
                        <input
                          name="companyName"
                          value={formData.companyName}
                          onChange={handleChange}
                        />
                      ) : (
                        app.companyName
                      )}
                    </td>
                    <td>
                      {editingId === app._id ? (
                        <input
                          name="companyLocation"
                          value={formData.companyLocation}
                          onChange={handleChange}
                        />
                      ) : (
                        app.companyLocation
                      )}
                    </td>
                    <td>
                      {editingId === app._id ? (
                        <textarea
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                        />
                      ) : (
                        app.description
                      )}
                    </td>
                    <td>
                      {editingId === app._id ? (
                        <>
                          <button
                            className="btn btn-save"
                            onClick={() => handleUpdate(app._id)}
                          >
                            Save
                          </button>
                          <button
                            className="btn btn-cancel"
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="btn btn-edit"
                            onClick={() => handleEdit(app)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-delete"
                            onClick={() => handleDelete(app._id)}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminProductApplications;
